import React from 'react'
import { ResponsiveLine } from '@nivo/line'
import { useAnalysis } from 'CRM/hooks/Dashboard/GetAnalysis';
import { ToolTipDate, ToolTipWrapper } from './styles';
import { Spin } from 'antd';
import {useIsMobile} from "./IsMobile";
import {MobileChartCalVW} from "./ChartCalVW";

export const AnalysisChart = () => {
  const { analysisData } = useAnalysis();
  const IsMobile = useIsMobile();

  if (!analysisData || analysisData.length === 0) {
    return (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <Spin />
      </div>
    )
  }

  return (
    <ResponsiveLine
        data={
          [
            {
              'id': '입금액',
              'color': '#F26B6B',
              'data': analysisData?.map(it => ({
                x: it?.date?.slice(5,10),
                y: it?.depositAmount
              })) || []
            },
            {
              'id': '회원수',
              'color': '#85F2B4',
              'data': analysisData?.map(it => ({
                x: it?.date?.slice(5,10),
                y: it?.userCount
              })) || []
            },
          ]
        }
        tooltip={ item => {
          return (
            <ToolTipWrapper style={{border: `1px solid ${item?.point?.borderColor}`}} IsMobile={IsMobile}>
              <ToolTipDate IsMobile={IsMobile}><span>날짜:</span><span style={{color: item?.point?.borderColor}}>{item?.point?.data?.xFormatted}</span></ToolTipDate>
              <ToolTipDate IsMobile={IsMobile}><span>{item?.point?.serieId}:</span><span style={{color: item?.point?.borderColor}}>{String(item?.point?.data?.yFormatted)?.split('.')?.[0]}</span></ToolTipDate>
            </ToolTipWrapper>
          )
        }}
        colors={{ scheme: 'category10' }}
        margin={{ top:  IsMobile ? MobileChartCalVW(110) : 30, right: IsMobile ? MobileChartCalVW(300) : 110, bottom: IsMobile ? MobileChartCalVW(230) : 60, left: IsMobile ? MobileChartCalVW(500) : 80 }}
        xScale={{ type: 'point' }}
        yScale={{
            type: 'linear',
            min: 'auto',
            max: 'auto',
            stacked: true,
            reverse: false
        }}
        yFormat=" >-.2f"
        axisTop={null}
        axisRight={null}
        axisBottom={{}}
        axisLeft={{}}
        pointSize={IsMobile ? MobileChartCalVW(10) : 10}
        pointColor={{ theme: 'background' }}
        pointBorderWidth={ IsMobile ? MobileChartCalVW(2) : 2}
        pointBorderColor={{ from: 'serieColor' }}
        pointLabelYOffset={ IsMobile ? MobileChartCalVW(-12) : -12}
        enableTouchCrosshair={true}
        useMesh={true}
        legends={[
            {
                anchor: 'bottom',
                direction: 'row',
                justify: false,
                translateX: IsMobile ? MobileChartCalVW(-570) : -570,
                translateY: IsMobile ? MobileChartCalVW(50) : 50,
                itemsSpacing: 0,
                itemDirection: 'left-to-right',
                itemWidth: IsMobile ? MobileChartCalVW(80) : 80,
                itemHeight: IsMobile ? MobileChartCalVW(20) : 20,
                itemOpacity: IsMobile ? MobileChartCalVW(0.75) : 0.75,
                symbolSize: IsMobile ? MobileChartCalVW(12) : 12,
                symbolShape: 'circle',
                symbolBorderColor: 'rgba(0, 0, 0, .5)',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemBackground: 'rgba(0, 0, 0, .03)',
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ]}
    />
  )
}

export default React.memo(AnalysisChart);